// extracted by mini-css-extract-plugin
export default {"notice":"notice-module--notice--1QCeC"};